const appMethod = {
	//进去app发帖子列表
	takePost: function(vm) {
    if(vm.$local.get('appOs') != '1') {
      vm.$router.push({
        name:'download'
      })
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.takePost.postMessage('')
      }
      if(os === 'AndroidOS') {
        window.webkit.takePost();
      }
    }
	},
	//跳转到保证金页面  vm---vue对象     postData---{sessionSeq: this.$route.params.Sseq,goodsSeq: this.$route.params.Gseq}
	bondPay: function(vm, postData) {
		//		alert(vm.$local.get('appOs'))
		if(vm.$local.get('appOs') != '1') {
			vm.$router.push({
				name: 'boonPay',
				query: postData
			})
		} else {
        //如果是没有登录的话要跳转到app的登录页面
			if(os === 'iOS') {
        Cookie.get('keyCode') ?  window.webkit.messageHandlers.bondPay.postMessage(JSON.stringify(postData)) : window.webkit.messageHandlers.goLogin.postMessage('');
			}
			if(os === 'AndroidOS') {
        Cookie.get('keyCode') ? window.webkit.bondPay(JSON.stringify(postData)) : window.webkit.goLogin();
			}
		}
	},
	//跳转到拍品详情页面              postData---{sessionSeq: this.$route.params.Sseq,goodsSeq: this.$route.params.Gseq}
	saleDetail: function(vm, postData) {
		vm.$router.push({
			name: 'goodsDetail',
			params: postData
		})
//		if(vm.$local.get('appOs') != '1') {
//			vm.$router.push({
//				name: 'goodsDetail',
//				params: postData
//			})
//		} else {
//			if(os == 'iOS') {
//				window.webkit.messageHandlers.saleDetail.postMessage(JSON.stringify(postData))
//			}
//			if(os == 'AndroidOS') {
//				window.webkit.saleDetail(JSON.stringify(postData));
//			}
//		}
	},
  //跳转到帖子详情页面
  postDetail: function(vm, postData) {       //postData---{pid:帖子id,type:1.分享帖，2酒评帖}
    if(vm.$local.get('appOs') != '1') {
      vm.$router.push({
        name: 'communityDetail',
        query: postData
      })
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.postDetail.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.postDetail(JSON.stringify(postData));
      }
    }
  },
  // 分享    postData---{shareUrl:分享链接 ,shareTitle:分享标题 , shareContent:分享内容, imgUrl:分享图片地址}
  share: function(vm, postData) {
    if(vm.$local.get('appOs') != '1') {
      // 不是APP时候的分享
    } else {
      if(os === 'iOS') {
        //todo:这里有坑，为了处理ios的httpss问题
        let newpostData = postData;
        newpostData.imgUrl = newpostData.imgUrl.replace('https','http');
        window.webkit.messageHandlers.share.postMessage(JSON.stringify(newpostData))
      }
      if(os === 'AndroidOS') {
        window.webkit.share(JSON.stringify(postData));
      }
    }
  },
  // 摇号商品 支付
  gotoLotteryPay: function(vm, params) {
    if(vm.$local.get('appOs') != '1') {
      // 不是APP时候的分享
    } else {
      if(os === 'iOS') {
        //todo:这里有坑，为了处理ios的httpss问题
        window.webkit.messageHandlers.goToBalanceCenter.postMessage(JSON.stringify(params))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToBalanceCenter(JSON.stringify(params));
      }
    }
  },
  //跳转到购物袋
  // goToShoppingBag: function(vm) {
  //   if(vm.$local.get('appOs') != '1') {
  //     vm.$router.push({
  //       name: "shoppingBag"
  //     })
  //   } else {
  //     if(os === 'iOS') {
  //       window.webkit.messageHandlers.goToShoppingCar.postMessage("")
  //     }
  //     if(os === 'AndroidOS') {
  //       window.webkit.goToShoppingBag();
  //     }
  //   }
  // },
  //跳转到全部商品
  goToAllMall: function(vm) {
    if(vm.$local.get('appOs') != '1') {
      vm.$router.push({
        name: "allMall"
      })
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToAllMall.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goToAllMall();
      }
    }
  },
  //跳转到拍卖首页
  gotoAuctionHome: function(vm) {
    if(vm.$local.get('appOs') != '1') {
      callback()
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.gotoAuctionHome.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.gotoAuctionHome();
      }
    }
  },
  //跳转到我的竞拍
  goToMyAuction: function(vm) {
    if(vm.$local.get('appOs') != '1') {
      callback()
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToMyAuction.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goToMyAuction();
      }
    }
  },
  // 跳转到小程序的某个页面 postData = {miniUrl: '小程序页面地址'}
  goToApplets: function(vm,postData){
    if(vm.$local.get('appOs') != '1') {
      callback()
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToApplets.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToApplets(JSON.stringify(postData));
      }
    }
  },
  //跳到盲品全部
  goToAllBlind: function(vm) {
    if(vm.$local.get('appOs') != '1') {
      vm.$router.push({
        name: "allBlind"
      })
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToAllMall.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goToAllMall();
      }
    }
  },
  //跳转到结算中心
  goToBalanceCenter: function(vm, postData, callback) {
    if(vm.$local.get('appOs') != '1') {
      callback()
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToBalanceCenter.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToBalanceCenter(JSON.stringify(postData));
      }
    }
  },
  //跳转到收银台
  goToEnroll: function(vm, postData, callback) {
    if(vm.$local.get('appOs') != '1') {
      callback()
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.enroll.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.enroll(JSON.stringify(postData));
      }
    }
  },
  //社区个人主页购买跳的新结算中心
  goToShareBarConfirmOrder: function(vm,postData){
    if(vm.$local.get('appOs') != '1') {
      callback()
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToShareBarConfirmOrder.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToShareBarConfirmOrder(JSON.stringify(postData));
      }
    }
  },
  //商品详情评价
  goToEvaluateList: function(vm,productId) {

    if(vm.$local.get('appOs') != '1') {
        vm.$router.push({
        name: "productReview"
      })
    } else {

      if(os === 'iOS') {

        window.webkit.messageHandlers.goToEvaluateList.postMessage(JSON.stringify(productId))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToEvaluateList(JSON.stringify(productId));
      }
    }
  },
  //动态设置活动H5页面title
  setNavbarTitle: function(vm,params) {
    if(os === 'iOS') {
      window.webkit.messageHandlers.setTitle.postMessage(JSON.stringify(params))
    }
    if(os === 'AndroidOS') {
      window.webkit.setTitle(JSON.stringify(params));
    }
  },

  //跳转到客服
  goToServer: function(vm, postData) {
    if(vm.$local.get('appOs') != '1') {
      //  不跳app
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToServer.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToServer(JSON.stringify(postData));
      }
    }
  },

  //跳转到app空瓶详情
  goHollowDetail :function (vm) {
    if(vm.$local.get('appOs') != '1') {
        vm.$router.push({
          name:'bottleDetail'
        })
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goHollowDetail.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goHollowDetail();
      }
    }
  },
  //进入写酒评页面
  goWhirtePost :function (vm,postData) {
    if(vm.$local.get('appOs') != '1') {

    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goWhirtePost.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goWhirtePost(JSON.stringify(postData));
      }
    }
  },

	//判断如果没有keyCode就跳到登录页面  vm---vue对象    callback已登录之后的回调函数     errback未登录的回调函数
	requireAuth: function(vm,callback,errback) {
    console.log("从cookie中获取登录信息：keyCode：====="+Cookie.get('keyCode')+"======== userSeq：========"+Cookie.get('userSeq'))
		if(Cookie.get('keyCode')) {
      if(typeof callback === 'function') {
        callback()
      }
		} else {
			if(vm.$local.get('appOs') !== '1') {
				if(typeof errback === 'function') {
					errback()
				}
				vm.$router.push({
					path: '/login',
					query: {redirect: vm.$route.fullPath}
				})
			} else {
				if(os === 'iOS') {
			 		window.webkit.messageHandlers.goLogin.postMessage('')
				}
				if(os === 'AndroidOS') {
					window.webkit.goLogin();
				}
			}
		}
	},
  //去认证
  goAprove(vm){
    if(vm.$local.get('appOs') !== '1') {
      vm.$layer.msg('请前往APP或者小程序实名认证');
    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goAprove.postMessage(JSON.stringify(''));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goAprove(JSON.stringify(''));
        }catch(e){
        }

      }
    }
  },

  //进入直播间   auctionSessionSeq  --- 拍场seq   liveId --- 直播频道id
  goLive(vm,postData) {
    if(vm.$local.get('appOs') !== '1') {
      //   进入h5直播
      //微信环境直接进入目睹解析的地址，微信不允许嵌入iframe
      if(vm.$UA == 'wechat'){
        window.location.href = vm.$live + postData.liveId;
      }else {
        vm.$router.push({
          name: 'live',
          query: postData
        })
      }
    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goLive.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goLive(JSON.stringify(postData));
        }catch(e){
        }

      }
    }
  },
  //进入云品鉴直播间 pid
  goYun(vm,postData) {
    if(vm.$local.get('appOs') !== '1') {

    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goYun.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goYun(JSON.stringify(postData));
        }catch(e){
        }

      }
    }
  },
  //返回上一页，如果有h5的页面就返回h5的页面，没有就调用app的返回方法
  goback(vm) {
    //判断是由h5返回还是由app返回
    console.log(vm.$route.query.platform)
    if(!(vm.$route.query.platform === "app")) {
      // window.history.back()
      vm.$router.go(-1)
    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goback.postMessage('');
        }catch(e){}
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goback();
        }catch(e){}
      }
    }
  },
  //去搜索页
  goSearch(vm,postData) {
    //判断是由h5返回还是由app返回
    if(!(vm.$route.query.platform === "app")) {

    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goSearch.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goSearch(JSON.stringify(postData));
        }catch(e){
        }

      }
    }

  },
  writeHistory(vm,postData) {
    //判断是由h5返回还是由app返回
    if(!(vm.$route.query.platform === "app")) {
    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.writeHistory.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.writeHistory(JSON.stringify(postData));
        }catch(e){
        }

      }
    }

  },
  //去视频详情
  goVideo(vm,postData) {
    //判断是由h5返回还是由app返回
    if(!(vm.$route.query.platform === "app")) {

    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goVideo.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goVideo(JSON.stringify(postData));
        }catch(e){
        }

      }
    }

  },
  //去新闻详情
  goNews(vm,postData) {
    //判断是由h5返回还是由app返回
    if(!(vm.$route.query.platform === "app")) {

    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goNews.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goNews(JSON.stringify(postData));
        }catch(e){}

      }
    }

  },
  //跳钱包
  goMyWallet: function(vm) {
    if(vm.$local.get('appOs') !== '1') {
      vm.$router.push({
        name: "myPurse",
      })
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goMyWallet.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goMyWallet();
      }
    }
  },


  //用原生打开图片
  openImgGroup(vm,postData) {
    //判断是由h5返回还是由app返回
    if(vm.$local.get('appOs') !== '1') {

    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.openImgGroup.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.openImgGroup(JSON.stringify(postData));
        }catch(e){}
      }
    }
  },
  //原生分类
  pushToMallBrandList(vm,postData) {
      if(vm.$local.get('appOs') !== '1') {
      } else {
        if(os === 'iOS') {
          try{
            window.webkit.messageHandlers.pushToMallBrandList.postMessage("");
          }catch(e){
          }
        }
        if(os === 'AndroidOS') {
          try{
            window.webkit.pushToMallBrandList();
          }catch(e){}
        }
      }
    },
    //跳原生领券中心
    goClickCouponCenter(vm,postData) {
      if(vm.$local.get('appOs') !== '1') {
        vm.$router.push({
          name: "VoucherCenter",
          })
      } else {
        if(os === 'iOS') {
          try{
            window.webkit.messageHandlers.goClickCouponCenter.postMessage(JSON.stringify(postData));
          }catch(e){
          }
        }
        if(os === 'AndroidOS') {
          try{
            window.webkit.goClickCouponCenter(JSON.stringify(postData));
          }catch(e){}
        }
      }
    },

  //跳众筹
  goMyCrowdFunding: function(vm) {
    if(vm.$local.get('appOs') !== '1') {

    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goMyCrowdFunding.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goMyCrowdFunding();
      }
    }
  },
  //跳骑士主页
  goToKnights: function(vm, postData) {
    if(vm.$local.get('appOs') !== '1') {
      vm.$router.push({
        name: "KnightsMember",
        })
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToKnights.postMessage(postData?JSON.stringify(postData):"")
      }
      if(os === 'AndroidOS') {
        window.webkit.goToKnights();
      }
    }
  },
  //跳原生全部商品，分类商品
  goToGoodsList(vm,postData) {
    if(vm.$local.get('appOs') !== '1') {
      if( postData.recommendName == '全部商品'){
        vm.$router.push({
          name: "allMall"
        })
      }
    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goToGoodsList.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goToGoodsList(JSON.stringify(postData));
        }catch(e){}
      }
    }
  },
  goToMallClassify(vm,postData) {
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        try{
          window.webkit.messageHandlers.goToMallClassify.postMessage(JSON.stringify(postData));
        }catch(e){
        }
      }
      if(os === 'AndroidOS') {
        try{
          window.webkit.goToMallClassify(JSON.stringify(postData));
        }catch(e){}
      }
    }
  },
  //调原生小脚标
  updateShoppingCarBadge(vm) {
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.updateShoppingCarBadge.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.updateShoppingCarBadge();
      }
    }
  },

  // 阶梯拼团 去支付定金
  goToPayBond(vm,postData) {
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToPayBond.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToPayBond(JSON.stringify(postData));
      }
    }
  },
  // 查看拼团详情
  goToGroupDetail(vm,postData) {
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToGroupDetail.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToGroupDetail(JSON.stringify(postData));
      }
    }
  },
  // 跳往订单详情
  goOrderDetail(vm,postData) {
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goOrderDetail.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goOrderDetail(JSON.stringify(postData));
      }
    }
  },
  //原生购物车界面
  goToShoppingCar(vm){
    if(vm.$local.get('appOs') !== '1') {
      vm.$router.push({ name: "shoppingBag" });
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToShoppingCar.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goToShoppingCar();
      }
    }
  },
  //原生绑定邮箱页面
  goToBindingEMail(vm){
    if(vm.$local.get('appOs') !== '1') {
      vm.$router.push({ name: "customerEmail" });
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToBindingEMail.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goToBindingEMail();
      }
    }
  },
  //个人主页资料编辑
  goToEditPersonalProfile(vm,postData){
    if(vm.$local.get('appOs') !== '1') {

    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToEditPersonalProfile.postMessage(JSON.stringify(postData))
      }
      if(os === 'AndroidOS') {
        window.webkit.goToEditPersonalProfile(JSON.stringify(postData));
      }
    }
  },
  //调相机扫快递码
  ScanBarcode(vm){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.ScanBarcode.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.ScanBarcode();
      }
    }
  },
  //社区主页右上角跳信息页
  goToMessageList(vm){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToMessageList.postMessage("")
      }
      if(os === 'AndroidOS') {
        window.webkit.goToMessageList();
      }
    }
  },
    writeLocalLog(postData){
        if(os === 'AndroidOS') {
          window.webkit.writeLocalLog(postData);
        }
    },
  //添加埋点信息
  commitBuryMessage(vm,postData){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.commitBuryMessage.postMessage(JSON.stringify(postData));
      }
      if(os === 'AndroidOS') {
        window.webkit.commitBuryMessage(JSON.stringify(postData));
      }
    }
  },
  //跳转更多秒杀活动
  goToAllSeckill(vm){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToAllSeckill.postMessage("");
      }
      if(os === 'AndroidOS') {
        window.webkit.goToAllSeckill();
      }
    }
  },
  // 邀请好友
  goToInviteFriends(vm){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToInviteFriends.postMessage("");
      }
      if(os === 'AndroidOS') {
        window.webkit.goToInviteFriends();
      }
    }
  },
  // 个人设置
  goToPersonalSetUp(vm){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goToPersonalSetUp.postMessage("");
      }
      if(os === 'AndroidOS') {
        window.webkit.goToPersonalSetUp();
      }
    }
  },
  // 调用原生拨打电话功能
  makeACall(vm, val){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.makeACall.postMessage(JSON.stringify(val));
      }
      if(os === 'AndroidOS') {
      }
    }
  },
  // 跳转到第三方的隐私政策（极光），由于原生端写死直接跳转到极光的隐私政策
  // 加入该方法主要原因是 安卓应用市场对于应用的基础信息审核通不过 必须加上引入第三方sdk的说明
  goAuroraPrivacy(vm){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {//IOS还未给方法
        // window.webkit.messageHandlers.goAuroraPrivacy.postMessage("");
      }
      if(os === 'AndroidOS') {//
        window.webkit.goAuroraPrivacy();
      }
    }
  },
  // 去收货地址列表
  goAddressList(vm){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goAddressList.postMessage("");
      }
      if(os === 'AndroidOS') {
        window.webkit.goAddressList();
      }
    }
  },
  // 修改收货地址
  goConsigneeAdd(vm, val){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goConsigneeAdd.postMessage(JSON.stringify(val));
      }
      if(os === 'AndroidOS') {
        window.webkit.goConsigneeAdd(JSON.stringify(val));
      }
    }
  },
  // 修改收货地址
  goToPromotionCondition(vm, params){
    if(vm.$local.get('appOs') !== '1') {
    } else {
      if(os === 'iOS') {
        window.webkit.messageHandlers.goPromotionCondition.postMessage(JSON.stringify(params));
      }
      if(os === 'AndroidOS') {
        window.webkit.goPromotionCondition(JSON.stringify(params));
      }
    }
  }
}

export default appMethod



// WEBPACK FOOTER //
// ./src/utils/app/unit.js